import { render, staticRenderFns } from "./reportForm.vue?vue&type=template&id=f218c56e&"
import script from "./reportForm.vue?vue&type=script&lang=js&"
export * from "./reportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/statistics/reportForm.vue"
export default component.exports